<template>
  <div class="login-box">
    <div class="loginWindow" >
      <div class='title'>博兴县基本公共服务提升后台</div>
      <el-form key="1" ref="loginFormRef" class="elForm-Login" :rules="loginRules" :model="loginForm" label-width="80px">
        <el-form-item label="账号" prop="username">
          <el-input v-model="loginForm.username" prefix-icon="el-icon-unlock" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="loginForm.password" :type="inpType" prefix-icon="el-icon-key" placeholder="请输入密码"></el-input>
          <img :src="inpType === 'password' ? urlclose : urlopen" class="eyes" @click="pwdStyle" />
        </el-form-item>
        <el-form-item class="elBtn">

          <el-button type="primary" @click="login">登录</el-button>
        </el-form-item>

      </el-form>
    </div>

  </div>
</template>

<script>

export default {
  data() {
    return {
      decide: true,
      registerShow: '1',
      token: 'admin123',
      urlopen: require('../assets/img/open.png'),
      urlclose: require('../assets/img/close.png'),
      inpType: 'password',
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [
          { required: true, message: '请输入正确的用户账号', trigger: 'blur' },
          {
            min: 8,
            max: 8,
            message: '请输入正确的用户账号',
            trigger: 'blur'
          }
        ],
        password: [
          { required: true, message: '请输入正确的用户密码', trigger: 'blur' },
          {
            min: 8,
            max: 8,
            message: '请输入正确的密码',
            trigger: 'blur'
          }
        ]
      },
    }
  },

  mounted() { },

  methods: {
    pwdStyle() {
      console.log(this.inpType)
      if (this.inpType === 'text') {
        this.inpType = 'password'
      } else {
        this.inpType = 'text'
      }
    },

    login() {
      const token = 'admin123'
      this.$refs.loginFormRef.validate((valid) => {
        if (!valid) {
          this.$message.error('登录失败')
        } else {
          if((this.loginForm.username==token)&&(this.loginForm.password==token)){
            this.$message.success('登录成功')
            window.sessionStorage.setItem('feedback', 'nice')
            this.$router.push('./home')
          }else{
            this.$message.error('密码错误')
          }

        }
      })
    },
    forgetpwd() {
      console.log(this.forgetForm)
    },
    forget() {
      this.registerShow = '3'
    },

  }

}
</script>

<style lang="less" scoped>
.title{font-size: 24px;font-weight: 800;text-align: center;
padding:40px 0;
color: #3f98b0;}
.login-box {
  background-color: #4aafc9;
  height: 100%;
}

.loginWindow {
  width: 500px;
  height: 300px;
  background-color: #fff;
  border-radius: 5px;
  margin: auto;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.loginWindow_s {
  width: 500px;
  height: 700px;
  background-color: #fff;
  border-radius: 5px;
  margin: auto;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.forget_from {
  width: 450px;
  height: 350px;
  padding-top: 80px;
  background-color: white;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 5px;
  padding-right: 40px;
  padding-left: 10px;
}

.heard_s {
  background-color: bisque;
  border-radius: 5px;
  width: 100%;
  height: 100%;

  img {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    width: 100%;
    height: 260px;
  }
}

.int_btn {
  width: 100px;
  background-color: #a6a9ad !important;
  border-radius: 5px !important;
  color: rgba(0, 0, 0, 0.548) !important;
  font-size: 14px !important;
  font-weight: 500;
}

.head {
  width: 130px;
  height: 130px;
  background-color: rgb(221, 221, 201);
  border-radius: 50%;
  border: 1px solid #eee;
  padding: 10px;
  box-shadow: 0 0 10px #ddd;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #eee;
  }
}

.elForm-Login {
  position: absolute;
  bottom: 0px;
  width: 90%;
}

.elBtn {
  display: flex;
  justify-content: flex-end;
}

.el-top {
  margin-bottom: 45px;
  padding-top: 20px;
}

.login-span {
  font-size: 12px;
  color: rgb(17, 85, 148);
  cursor: pointer;
  margin-right: 100px;
}

.forget-span {
  font-size: 12px;
  color: rgb(17, 85, 148);
  cursor: pointer;
  margin-right: 100px;
}

.login-span-verificationCode {
  font-size: 12px;
  color: rgb(17, 85, 148);
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 30px;
}

.el-input-group__append {
  border: 0px;
  background-color: transparent !important;
}

.login-forget-span {
  font-size: 12px;
  color: rgb(17, 85, 148);
  margin-right: 40px;
  cursor: pointer;
}

.eyes {
  position: absolute;
  right: 5px;
  top: 5px;
  width: 30px;
  height: 70%;
  cursor: pointer;
}
</style>
